String.prototype.capitalize = function() {
    return this.charAt(0).toUpperCase() + this.toLowerCase().slice(1)
}


String.prototype.nl2br = function() {
    return this.replace(/(?:\r\n|\r|\n)/g, '<br>');
}

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue').default;

import {
    BootstrapVue,
    IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
    // Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

import VueLaroute from 'vue-laroute';
import routes from './laroute';

Vue.use(VueLaroute, {
    routes,
    accessor: '$routes', // Optional: the global variable for accessing the router
});

import Permissions from './mixins/Permissions';
Vue.mixin(Permissions);

var {
    DateTime
} = require('luxon');
window.DateTime = DateTime;

import Tabulator from 'tabulator-tables';
import Vue from 'vue';
window.Tabulator = Tabulator;

window.moment = require('moment');

import Echo from 'laravel-echo';
window.Pusher = require('pusher-js');
if (window.role) {
    // window.Echo = new Echo({
    //     broadcaster: 'pusher',
    //     key: 'e1f2cb6f977a071ec787', // Use the same key as in your .env
    //     wsHost: window.location.hostname,
    //     wsPort: 6001,
    //     wssPort: 6001,
    //     cluster: 'eu',
    //     disableStats: true,
    //     forceTLS: false,
    //     enabledTransports: ['ws', 'wss'] // Set to true if you're using SSL
    // });
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: 'e1f2cb6f977a071ec787',
        cluster: 'eu',
        encrypted: true
    });
}


// window.Echo.private('self-booking')
//     .listen('SelfBookingMade', (e) => {
//         console.log(e);
//         // Display your notification here
//         this.$bvToast.toast(`Booking from ${booking.member.forename} ${booking.member.surname} for game on ${booking.game.start_time} made`, {
//             title: 'Self Booking Made',
//             autoHideDelay: 5000,
//         })
//     });

// Pusher.logToConsole = true;

// var pusher = new Pusher('e1f2cb6f977a071ec787', {
//     cluster: 'eu'
// });

// var channel = pusher.subscribe('self-booking');

// channel.bind('self-booking', function(data) {
//     console.log(data);
// });

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

require('./vuecomponents');

var Modal = require('./modal');
window.modal = new Modal();

import CookieLaw from 'vue-cookie-law';

// Vue.use(CookieLaw);
Vue.component('cookie-law', CookieLaw);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: '#app',
    data() {
        return {
            modal: window.modal,
        }
    },
    mounted() {
        if (window.role) {
            window.Echo.private('self-booking')
            .listen('SelfBookingMade', (e) => {
                // Display your notification here
                // Trigger a toast message
                this.$bvToast.toast(`New Self Booking from ${e.booking.member.forename} ${e.booking.member.surname} for game on ${moment(e.booking.game.start_time).format('DD-MM-YYYY')}`, {
                    title: 'Self Booking Made',
                    autoHideDelay: 5000,
                })
            });
            window.Echo.private('booking-cancel')
            .listen('BookingCancelled', (e) => {
                // Display your notification here
                // Trigger a toast message
                this.$bvToast.toast(`Booking Self Cancelled ${e.member.forename} ${e.member.surname} for game on ${moment(e.game.start_time).format('DD-MM-YYYY')}`, {
                    title: 'Booking Self Cancelled',
                    autoHideDelay: 5000,
                })
            });
            window.Echo.private('marshal')
            .listen('MarshalNoteAdded', (e) => {
                this.$bvToast.toast(`New marshal note added for ${e.booking.member.forename} ${e.booking.member.surname} by ${e.note.user.name} saying ${e.note.message}`, {
                    title: 'Marshal Note Added',
                    autoHideDelay: 5000,
                    href: this.$routes.route('game.show', {game: e.booking.game.id}),
                })
            });
        }
    }
});
